import React, { useEffect } from 'react';
import { _$ } from '../../../../controllers/dom';
import { locales } from '../../../../translations/locales';

const CheckList = (props) => {
    const { locale, configType, data } = props;

    const checkAll = (type) => {
        if (_$(type).checked) {
            _$(type).checked = true;
            _$(type + '-new').checked = true;
            _$(type + '-manage').checked = true;
            _$(type + '-delete').checked = true;
        } else {
            _$(type).checked = false;
            _$(type + '-new').checked = false;
            _$(type + '-manage').checked = false;
            _$(type + '-delete').checked = false;
        }
    };

    const testCheck = (type) => {
        let isCheck = false;
        if (_$(type + '-new').checked || _$(type + '-manage').checked || _$(type + '-delete').checked) {
            isCheck = true;
        }
        if (isCheck) {
            _$(type).checked = true;
        } else {
            _$(type).checked = false;
        }
    };

    useEffect(() => {
        if (data && data.authorizations) {
            testCheck(configType);
        }
    });

    return (
        <>
            <div className='form-check'>
                <input className='form-check-input' type='checkbox' id={configType} onClick={() => checkAll(configType)} />
                <label className='form-check-label' htmlFor={configType}>
                    {locales[locale].auth.admin[configType]}
                </label>
            </div>
            <div className='form-check ml-4'>
                <input className='form-check-input' type='checkbox'
                    id={`${configType}-new`}
                    onClick={() => testCheck(configType)}
                    defaultChecked={`${data && data.authorizations.admin[configType].new ? data.authorizations.admin[configType].new : ''}`}
                />
                <label className='form-check-label' htmlFor={`${configType}-new`}>
                    {locales[locale].auth.new}
                </label>
            </div>
            <div className='form-check ml-4'>
                <input className='form-check-input' type='checkbox'
                    id={`${configType}-manage`}
                    onClick={() => testCheck(configType)}
                    defaultChecked={`${data && data.authorizations.admin[configType].manage ? data.authorizations.admin[configType].manage : ''}`}
                />
                <label className='form-check-label' htmlFor={`${configType}-manage`}>
                    {locales[locale].auth.manage}
                </label>
            </div>
            <div className='form-check ml-4'>
                <input className='form-check-input' type='checkbox'
                    id={`${configType}-delete`}
                    onClick={() => testCheck(configType)}
                    defaultChecked={`${data && data.authorizations.admin[configType].delete ? data.authorizations.admin[configType].delete : ''}`}
                />
                <label className='form-check-label' htmlFor={`${configType}-delete`}>
                    {locales[locale].auth.delete}
                </label>
            </div>
        </>
    );
};

export default CheckList;
